// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa483778","455":"247f589a","977":"8cc98560"}[chunkId] + ".chunk.js";
};